import { ReactNode } from 'react';

import { cx } from '@libs/classnames';
import { ArrowHeadIcon } from '@ui/icons/ArrowHeadIcon';
import { BackNavIcon } from '@ui/icons/BackNavIcon/BackNavIcon';

import styles from './BackNavButton.module.css';

type Props = {
  className?: string;
  title?: string;
  children: ReactNode;
};
export function BackNavButton({ className, title, children }: Props) {
  return (
    <div className={cx(styles.backNavButton, className)} title={title}>
      <BackNavIcon className={styles.outline} />

      <ArrowHeadIcon className={styles.arrowIcon} />
      <div className={styles.content}>{children}</div>
    </div>
  );
}
